import { createdAtSorter } from '@/lib/generic.utils'
// Components
import EntityLink from '@components/ag-grid-helpers/EntityLink'

export default {
  computed: {
    gridOptions() {
      return {
        rowData: this.importedProviders,
        masterDetail: true,
        columnDefs: [
          {
            headerName: 'Import',
            field: 'id',
            tooltipValueGetter: params => `Import ${params.value}`,
            cellRendererParams: params => {
              return {
                customData: {
                  id: params.value,
                  routeName: 'provider-import',
                  prefix: 'Import ',
                  label: params.value
                }
              }
            },
            cellRendererFramework: EntityLink
          },
          {
            headerName: 'Date of import',
            field: 'created_at',
            comparator: createdAtSorter,
            cellRenderer: params => this.formatDateTimeForLocale(params.value),
            tooltipValueGetter: params => this.formatDateTimeForLocale(params.value)
          }
        ],
        detailCellRendererParams: {
          detailGridOptions: {
            masterDetail: true,
            columnDefs: [
              {
                field: 'id',
                tooltipField: 'id',
                headerName: 'Subscription name'
              },
              {
                field: 'publisher',
                tooltipField: 'publisher',
                headerName: 'Publisher'
              },
              {
                field: 'vendor',
                tooltipField: 'vendor',
                headerName: 'Vendor'
              }
            ],
            detailCellRendererParams: {
              detailGridOptions: {
                columnDefs: []
              }
            }
          }
        }
      }
    }
  }
}
